export const noTestsMessage = 'No tests to display';
export const selectSubjectMessage = 'Please select a subject';
